module.exports = __webpack_public_path__ + "img/pending_blue.c2b9f8eb.png";